export default __webpack_public_path__ + "static/media/EditarTalhoesImage.4427f9d7.svg";